const invoiceResult = {
  path: 'invoiceResult',
  component: resolve => require(['../../../../components/pages/signUp/invoiceResult'], resolve)
}
export default invoiceResult
